import { Dropdown, Image, Modal } from "react-bootstrap";
import "../../asset/css/styles.css";
import avatar from "../../asset/images/bydefault.png";
import { useEffect, useState, useRef } from "react";
import { getAllSprints } from "../../pages/api/sprint";
import "bootstrap-icons/font/bootstrap-icons.css";
import { changePassword, getAllUsers } from "../../../src/pages/api/resetpassword";
import { toast } from "react-toastify";
import bcrypt from "bcryptjs";
import { getMyProfile, updateMyProfilePicture, resolvePhotoUrl } from "../../pages/api/profile";
import NotificationModal from "../../notifications/NotificationModal";
import useNotifications from "../../notifications/useNotifications";


const NavbarPage = () => {
  const [, setSprints] = useState([]);
  const [, setSelectedTeam] = useState(null);
  const [, setSelectedSprint] = useState(null);

  const userName = localStorage.getItem("userName");
  const roleId = localStorage.getItem("roleId");
  const token = localStorage.getItem("token");

  const roleName =
    roleId === "1" ? "Admin" : roleId === "2" ? "Admin" :
      roleId === "3" ? "Employee" : "User";

  const [showNotifPanel, setShowNotifPanel] = useState(false);
  const [showSettingsPanel, setShowSettingsPanel] = useState(false);
  const notifRef = useRef(null);
  const settingsRef = useRef(null);

  const [sprintList, setSprintList] = useState([]);
  const [showNotifModal, setShowNotifModal] = useState(false);
  const { notifications, setNotifications } = useNotifications();
  const [notifEnabled, setNotifEnabled] = useState(true);

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const [userEmail, setUserEmail] = useState("");
  const [userData, setUserData] = useState(null);
  const [, setAllUsers] = useState([]);
  const [ddOpen, setDdOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [profileDetails, setProfileDetails] = useState(null);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
  const [loadingProfileDetails, setLoadingProfileDetails] = useState(false);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const editFileInputRef = useRef(null);
  const [photoError, setPhotoError] = useState("");
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [cropImgSrc, setCropImgSrc] = useState(null);
  const [cropZoom, setCropZoom] = useState(1);
  const [cropOffset, setCropOffset] = useState({ x: 0, y: 0 });
  const [cropDragging, setCropDragging] = useState(false);
  const [cropDragStart, setCropDragStart] = useState({ x: 0, y: 0 });
  const cropImgRef = useRef(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmNewPasswordError, setConfirmNewPasswordError] = useState("");
  const [, setPasswordError] = useState("");

  /* ── close panels on outside click ── */
  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) setShowNotifPanel(false);
      if (settingsRef.current && !settingsRef.current.contains(e.target)) setShowSettingsPanel(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* ── load email ── */
  useEffect(() => {
    const load = () => setUserEmail(localStorage.getItem("email"));
    load();
    window.addEventListener("storage", load);
    return () => window.removeEventListener("storage", load);
  }, []);

  /* ── load localStorage team/sprint ── */
  useEffect(() => {
    const t = localStorage.getItem("selectedTeam");
    if (t) setSelectedTeam(JSON.parse(t)); else setSelectedTeam(null);
    const s = localStorage.getItem("selectedSprint");
    if (s) setSelectedSprint(JSON.parse(s));
  }, []);

  /* ── fetch sprints ── */
  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await getAllSprints(token);
        if (res.status === 200) {
          const data = res.data;
          setSprints(data);
          setSprintList(data);
          const saved = localStorage.getItem("selectedSprint");
          if (saved) return;
          const today = new Date(); today.setHours(0, 0, 0, 0);
          const active = data.find(sp => {
            const s = new Date(sp.startDate); s.setHours(0, 0, 0, 0);
            const e = new Date(sp.endDate); e.setHours(23, 59, 59, 999);
            return today >= s && today <= e;
          });
          if (active) {
            setSelectedSprint(active);
            localStorage.setItem("selectedSprint", JSON.stringify(active));
            window.dispatchEvent(new Event("sprintChanged"));
          }
        }
      } catch (err) { console.error(err); }
    };
    if (token) fetch_();
  }, [token]);

  /* ── listen for sprint list updates ── */
  useEffect(() => {
    const h = async () => {
      const res = await getAllSprints(token);
      if (res.status === 200) { setSprints(res.data); setSprintList(res.data); }
    };
    window.addEventListener("sprintListUpdated", h);
    return () => window.removeEventListener("sprintListUpdated", h);
  }, [token]);

  /* ── fetch all users ── */
  useEffect(() => {
    const fetch_ = async () => {
      try {
        const t = localStorage.getItem("token");
        const currentUserName = localStorage.getItem("userName");
        const resp = await getAllUsers(t);
        const users = resp.data || resp;
        if (!users?.length) return;
        setAllUsers(users);
        const me = users.find(u => u.name?.toLowerCase().trim() === currentUserName?.toLowerCase().trim());
        if (me) setUserData(me);
      } catch (err) { console.error(err); }
    };
    fetch_();
  }, []);

  /* ── listen for openSettingsPanel ── */
  useEffect(() => {
    const handler = () => setShowSettingsPanel(true);
    window.addEventListener("openSettingsPanel", handler);
    return () => window.removeEventListener("openSettingsPanel", handler);
  }, []);

  /* ── fetch full profile on load (drives both navbar avatar and edit panel) ── */
  useEffect(() => {
    if (!token) return;
    const id = Number(localStorage.getItem("id"));
    setLoadingProfileDetails(true);
    getMyProfile(token, id)
      .then(async (data) => {
        setProfileDetails(data);
        const url = await resolvePhotoUrl(token, data.photoUrl);
        if (url) setProfilePhotoUrl(url);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoadingProfileDetails(false));
  }, [token]);

  /* ── password helpers ── */
  const validatePassword = (pwd) => {
    if (!pwd) return "Password is required";
    if (/\s/.test(pwd)) return "Password cannot contain spaces";
    if (pwd.length < 8) return "Must be at least 8 characters";
    if (!/[A-Z]/.test(pwd)) return "Must contain an uppercase letter";
    if (!/[a-z]/.test(pwd)) return "Must contain a lowercase letter";
    if (!/[0-9]/.test(pwd)) return "Must contain a number";
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(pwd)) return "Must contain a special character";
    return "";
  };

  const handleCurrentPasswordChange = async (e) => {
    const v = e.target.value; setCurrentPassword(v);
    if (!v.trim()) { setCurrentPasswordError("Current password is required"); return; }
    try {
      const ok = await bcrypt.compare(v, userData?.password || "");
      setCurrentPasswordError(ok ? "" : "Current password is incorrect!");
    } catch { setCurrentPasswordError("Something went wrong."); }
  };

  const handleNewPasswordChange = (e) => {
    const v = e.target.value; setNewPassword(v);
    setNewPasswordError(validatePassword(v));
    if (confirmNewPassword) setConfirmNewPasswordError(v !== confirmNewPassword ? "Passwords do not match" : "");
  };

  const handleConfirmNewPasswordChange = (e) => {
    const v = e.target.value; setConfirmNewPassword(v);
    if (!v.trim()) setConfirmNewPasswordError("Confirm password is required");
    else if (v !== newPassword) setConfirmNewPasswordError("Passwords do not match");
    else setConfirmNewPasswordError("");
  };

  const handleChangePassword = async () => {
    let err = false;
    if (!currentPassword.trim()) { setCurrentPasswordError("Current password is required"); err = true; }
    if (!newPassword.trim()) { setNewPasswordError("New password is required"); err = true; }
    if (!confirmNewPassword.trim()) { setConfirmNewPasswordError("Confirm password is required"); err = true; }
    if (newPassword && confirmNewPassword && newPassword !== confirmNewPassword) {
      setConfirmNewPasswordError("Passwords do not match"); err = true;
    }
    if (err) return;
    if (!userData?.password) { setCurrentPasswordError("User data not available. Please refresh."); return; }
    try {
      const ok = await bcrypt.compare(currentPassword, userData.password);
      if (!ok) { setCurrentPasswordError("Current password is incorrect!"); return; }
    } catch { setCurrentPasswordError("Error validating password"); return; }
    const pErr = validatePassword(newPassword);
    if (pErr) { setNewPasswordError(pErr); return; }
    setIsChangingPassword(true);
    try {
      const t = localStorage.getItem("token");
      const resp = await changePassword(currentPassword, newPassword, t);
      if (resp.statusCode === 200 || resp.data?.statusCode === 200 || resp.message === "Password changed successfully.") {
        toast.success("Password changed successfully!");
        setShowChangePasswordModal(false);
        resetChangePasswordForm();
        localStorage.clear();
        window.location.href = "/";
      } else { setPasswordError(resp.message || "Failed to change password"); }
    } catch (e) { setPasswordError(e.response?.data?.message || "Error changing password"); }
    finally { setIsChangingPassword(false); }
  };

  const resetChangePasswordForm = () => {
    setCurrentPassword(""); setNewPassword(""); setConfirmNewPassword("");
    setShowCurrentPassword(false); setShowNewPassword(false); setShowConfirmPassword(false);
    setCurrentPasswordError(""); setNewPasswordError(""); setConfirmNewPasswordError("");
  };

  const openChangePassword = () => { resetChangePasswordForm(); setShowChangePasswordModal(true); };

  /* ── sprint helpers ── */
  const sprintStatus = (sp) => {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const s = new Date(sp.startDate); s.setHours(0, 0, 0, 0);
    const e = new Date(sp.endDate); e.setHours(23, 59, 59, 999);
    if (today >= s && today <= e) return "active";
    if (today < s) return "upcoming";
    return "done";
  };

  const daysLeft = (sp) => Math.ceil((new Date(sp.endDate) - new Date()) / 86400000);

  const unreadCount = sprintList.filter(sp => sprintStatus(sp) !== "done").length;

  const navigateToSprintTab = (tab, dashBase, eventName) => {
    if (window.location.pathname === dashBase) {
      window.dispatchEvent(new CustomEvent(eventName, { detail: tab }));
    } else {
      window.location.href = dashBase + "?tab=" + tab;
    }
  };

  /* ════════════════ RENDER ════════════════ */
  return (
    <>
      {/* ── NAVBAR ── */}
      <nav className="hr-topnav">

        {/* Hamburger */}
        <button className="hn-hamburger" title="Toggle sidebar"
          onClick={() => window.dispatchEvent(new CustomEvent("toggleSidebar"))}>
          <i className="bi bi-list"></i>
        </button>

        {/* Brand */}
        <div className="hn-brand">
          <span className="hn-brand-name">Global Solution's <span>Orbit</span></span>
        </div>

        {/* Right actions */}
        <div className="hn-actions">

          {/* Notifications */}
          <div style={{ position: "relative" }} ref={notifRef}>
            <button
              className={`hn-icon-btn${showNotifModal ? " active-btn" : ""}`}
              title="Notifications"
              onClick={() => {
                setShowNotifModal(true);
                setShowSettingsPanel(false);
              }}
            >
              <i className={`bi bi-bell${showNotifModal ? "-fill" : ""}`}></i>
              {notifications.filter((n) => !n.read).length > 0 && (
                <span className="hn-notif-badge">
                  {notifications.filter((n) => !n.read).length > 9 ? "9+" : notifications.filter((n) => !n.read).length}
                </span>
              )}
            </button>

            <NotificationModal
              show={showNotifModal}
              onHide={() => setShowNotifModal(false)}
              notifications={notifications}
              setNotifications={setNotifications}
            />
          </div>

          {/* Settings */}
          <div style={{ position: "relative" }} ref={settingsRef}>
            <button
              className={`hn-icon-btn${showSettingsPanel ? " active-btn" : ""}`}
              title="Settings"
              onClick={() => { setShowSettingsPanel(p => !p); setShowNotifPanel(false); }}
            >
              <i
                className={`bi bi-gear${showSettingsPanel ? "-fill" : ""}`}
                /* rotation stays inline — driven by JS state */
                style={{ transition: "transform .35s", transform: showSettingsPanel ? "rotate(90deg)" : "rotate(0deg)" }}
              ></i>
            </button>

            {showSettingsPanel && (
              <div className="hn-panel">
                <div className="hn-panel-header">
                  <span className="hn-panel-title"><i className="bi bi-gear-fill"></i> Settings</span>
                  <button className="hn-panel-close" onClick={() => setShowSettingsPanel(false)}><i className="bi bi-x-lg"></i></button>
                </div>
                <div className="hn-panel-body">
                  <div className="hn-st-section">Account</div>
                  <div className="hn-st-row">
                    <div className="hn-st-info">
                      <div className="hn-st-label"><i className="bi bi-person-circle"></i> Logged in as</div>
                      <div className="hn-st-value">{userName || "User"} · <span style={{ color: "#2563eb" }}>{roleName}</span></div>
                    </div>
                  </div>

                  <div className="hn-st-row clickable" onClick={() => { setShowSettingsPanel(false); openChangePassword(); }}>
                    <div className="hn-st-info">
                      <div className="hn-st-label"><i className="bi bi-shield-lock"></i> Change Password</div>
                      <div className="hn-st-value">Update your login password</div>
                    </div>
                    <i className="bi bi-chevron-right" style={{ color: "#94a3b8", fontSize: "13px" }}></i>
                  </div>

                  <div className="hn-st-section" style={{ marginTop: "8px" }}>Display</div>
                  <div className="hn-st-row">
                    <div className="hn-st-info">
                      <div className="hn-st-label"><i className="bi bi-sun"></i> Theme</div>
                      <div className="hn-st-value">Light mode (default)</div>
                    </div>
                    <div className="hn-toggle on" style={{ cursor: "default" }}><span className="hn-toggle-thumb"></span></div>
                  </div>
                  <div className="hn-st-row">
                    <div className="hn-st-info">
                      <div className="hn-st-label"><i className="bi bi-bell"></i> Sprint notifications</div>
                      <div className="hn-st-value">{notifEnabled ? "Enabled – showing sprint alerts" : "Disabled"}</div>
                    </div>
                    <div className="hn-toggle-wrap" onClick={() => setNotifEnabled(v => !v)} title="Toggle notifications">
                      <div className={`hn-toggle${notifEnabled ? " on" : ""}`}>
                        <span className="hn-toggle-thumb"></span>
                      </div>
                    </div>
                  </div>

                  <div className="hn-st-section" style={{ marginTop: "8px" }}>Session</div>
                  <div className="hn-st-row clickable" onClick={() => { localStorage.clear(); window.location.href = "/"; }}>
                    <div className="hn-st-info">
                      <div className="hn-st-label" style={{ color: "#ef4444" }}><i className="bi bi-box-arrow-right"></i> Logout</div>
                      <div className="hn-st-value">Sign out of your account</div>
                    </div>
                    <i className="bi bi-chevron-right" style={{ color: "#fca5a5", fontSize: "13px" }}></i>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* User pill */}

          <Dropdown align="end" show={ddOpen} onToggle={(open) => {
            setDdOpen(open);
            if (open) { setShowNotifPanel(false); setShowSettingsPanel(false); setEditMode(true); }
            if (!open) { setEditMode(false); setPhotoError(""); }
          }}>
            <Dropdown.Toggle as="div" bsPrefix=" " className="hn-user-pill">
              <div className="hn-avatar">
                <Image alt="avatar" src={profilePhotoUrl || avatar} onError={e => e.target.src = avatar} />
              </div>              <div>
                <div className="hn-uname">{userName || "User"}</div>
                <div className="hn-urole">{roleName}</div>
              </div>
              {/* chevron rotation stays inline — driven by Bootstrap Dropdown open state */}
              <i className="bi bi-chevron-down" style={{ fontSize: "11px", color: "#94a3b8", marginLeft: "2px" }}></i>
            </Dropdown.Toggle>

            <Dropdown.Menu className="hn-dropdown-menu" renderOnMount style={editMode ? { minWidth: 250 } : undefined}>
              {editMode && (
                <div onClick={(e) => e.stopPropagation()} style={{ padding: "14px" }}>
                  <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 4 }}>
                    <button
                      onClick={() => { setDdOpen(false); setPhotoError(""); }}
                      style={{ background: "none", border: "none", color: "#94a3b8", fontSize: 16, cursor: "pointer", padding: 4, lineHeight: 1 }}
                      title="Close"
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>

                  {loadingProfileDetails ? (
                    <div style={{ padding: "24px 0", textAlign: "center", color: "#94a3b8", fontSize: 13 }}>
                      Loading...
                    </div>
                  ) : (
                    <>
                      {/* Avatar + upload */}
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 14 }}>
                        <div style={{ position: "relative", width: 96, height: 96 }}>
                          {profilePhotoUrl ? (
                            <img src={profilePhotoUrl} alt="Profile"
                              style={{ width: 96, height: 96, borderRadius: "50%", objectFit: "cover", border: "3px solid #2563eb" }} />
                          ) : (
                            <div style={{
                              width: 96, height: 96, borderRadius: "50%", background: "#2563eb",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              color: "#fff", fontSize: 26, fontWeight: 700,
                              border: "3px solid #2563eb",
                            }}>
                              {(profileDetails?.name || userName || "?").trim().split(/\s+/).slice(0, 2).map(w => w[0]?.toUpperCase()).join("")}
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={() => editFileInputRef.current?.click()}
                            disabled={uploadingPhoto}
                            title="Change photo"
                            style={{
                              position: "absolute", bottom: 6, right: 0, width: 28, height: 28, borderRadius: "50%",
                              background: "#2563eb", border: "3px solid #fff", cursor: "pointer",
                              display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
                            }}
                          >
                            <i className={uploadingPhoto ? "bi bi-arrow-repeat" : "bi bi-camera-fill"}
                              style={{ fontSize: 12, animation: uploadingPhoto ? "spin 1s linear infinite" : "none" }}></i>
                          </button>
                          <input
                            ref={editFileInputRef}
                            type="file" accept="image/jpeg,image/png"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              e.target.value = "";
                              if (!file) return;
                              setPhotoError("");

                              const allowedTypes = ["image/jpeg", "image/png"];
                              if (!allowedTypes.includes(file.type)) {
                                setPhotoError("Only JPG, JPEG, or PNG images are allowed.");
                                return;
                              }
                              if (file.size > 1 * 1024 * 1024) {
                                setPhotoError("Image must be smaller than 1MB.");
                                return;
                              }
                              const objectUrl = URL.createObjectURL(file);
                              const img = new window.Image();
                              img.onload = () => {
                                if (img.naturalWidth < 200 || img.naturalHeight < 200) {
                                  setPhotoError("Image must be at least 200×200px.");
                                  URL.revokeObjectURL(objectUrl);
                                  return;
                                }
                                setCropImgSrc(objectUrl);
                                setCropZoom(1);
                                setCropOffset({ x: 0, y: 0 });
                                setCropModalOpen(true);
                              };
                              img.onerror = () => setPhotoError("Could not read this image.");
                              img.src = objectUrl;
                            }}
                          />
                        </div>
                        {photoError && (
                          <div style={{ color: "#ef4444", fontSize: 11.5, marginTop: 8, textAlign: "center" }}>
                            {photoError}
                          </div>
                        )}
                      </div>

                      {/* Section 1 — Name / Contact / Email */}
                      {[
                        { label: "Name", value: profileDetails?.name || userData?.name || userName },
                        { label: "Contact Number", value: profileDetails?.mobile || profileDetails?.mobileNo || userData?.mobileNo || userData?.mobile || userData?.phone },
                        { label: "Email", value: profileDetails?.email || userData?.email || userEmail },
                      ].map((f) => (
                        <div key={f.label} style={{ marginBottom: 10 }}>
                          <div style={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".04em" }}>
                            {f.label}
                          </div>
                          <div style={{ fontSize: 13.5, color: "#1e293b", marginTop: 2 }}>
                            {f.value || "-"}
                          </div>
                        </div>
                      ))}

                      <div style={{ height: 1, background: "#f1f5f9", margin: "10px 0" }}></div>

                      {/* Section 2 — Department / Designation */}
                      <div style={{ display: "flex", gap: 12, marginBottom: 10 }}>
                        {[
                          { label: "Department", value: userData?.departmentName },
                          { label: "Designation", value: profileDetails?.designationName || profileDetails?.designation || userData?.designationName || userData?.designation },
                        ].map((f) => (
                          <div key={f.label} style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".04em" }}>
                              {f.label}
                            </div>
                            <div style={{ fontSize: 13.5, color: "#1e293b", marginTop: 2 }}>
                              {f.value || "-"}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div style={{ height: 1, background: "#f1f5f9", margin: "10px 0 10px" }}></div>

                      <button
                        onClick={() => { localStorage.clear(); window.location.href = "/"; }}
                        style={{ background: "none", border: "none", color: "#ef4444", fontSize: 13, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, padding: "6px 2px" }}>
                        <i className="bi bi-box-arrow-right"></i> Logout
                      </button>
                    </>
                  )}
                </div>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </nav>

      {/* ── Photo Crop Modal ── */}
      {cropModalOpen && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setCropModalOpen(false)}
        >
          <div onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 14, padding: 20, width: 320, boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b", marginBottom: 12 }}>Crop Photo</div>

            <div
              style={{ width: 260, height: 260, margin: "0 auto", borderRadius: "50%", overflow: "hidden", position: "relative", background: "#f1f5f9", cursor: cropDragging ? "grabbing" : "grab", border: "2px solid #e2e8f0" }}
              onMouseDown={(e) => { setCropDragging(true); setCropDragStart({ x: e.clientX - cropOffset.x, y: e.clientY - cropOffset.y }); }}
              onMouseMove={(e) => { if (!cropDragging) return; setCropOffset({ x: e.clientX - cropDragStart.x, y: e.clientY - cropDragStart.y }); }}
              onMouseUp={() => setCropDragging(false)}
              onMouseLeave={() => setCropDragging(false)}
            >
              {cropImgSrc && (
                <img
                  ref={cropImgRef}
                  src={cropImgSrc}
                  alt="Crop preview"
                  draggable={false}
                  style={{ position: "absolute", top: "50%", left: "50%", transform: `translate(-50%, -50%) translate(${cropOffset.x}px, ${cropOffset.y}px) scale(${cropZoom})`, maxWidth: "none", userSelect: "none" }}
                  onLoad={(e) => {
                    const el = e.target;
                    const minSide = Math.min(el.naturalWidth, el.naturalHeight);
                    const baseScale = 260 / minSide;
                    el.style.width = `${el.naturalWidth * baseScale}px`;
                    el.style.height = `${el.naturalHeight * baseScale}px`;
                  }}
                />
              )}
            </div>

            <input type="range" min="1" max="3" step="0.01" value={cropZoom}
              onChange={(e) => setCropZoom(Number(e.target.value))}
              style={{ width: "100%", marginTop: 14 }} />

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
              <button onClick={() => setCropModalOpen(false)}
                style={{ padding: "7px 16px", borderRadius: 6, border: "1px solid #e5e7eb", background: "#fff", fontSize: 13 }}>
                Cancel
              </button>
              <button
                onClick={() => {
                  const imgEl = cropImgRef.current;
                  if (!imgEl) return;
                  const outputSize = 320;
                  const canvas = document.createElement("canvas");
                  canvas.width = outputSize;
                  canvas.height = outputSize;
                  const ctx = canvas.getContext("2d");

                  const displayedW = imgEl.clientWidth * cropZoom;
                  const displayedH = imgEl.clientHeight * cropZoom;
                  const scaleToNatural = imgEl.naturalWidth / imgEl.clientWidth;
                  const circleSize = 260;
                  const imgLeft = (circleSize / 2) - (displayedW / 2) + cropOffset.x;
                  const imgTop = (circleSize / 2) - (displayedH / 2) + cropOffset.y;
                  const sx = (-imgLeft) * scaleToNatural / cropZoom;
                  const sy = (-imgTop) * scaleToNatural / cropZoom;
                  const sSize = circleSize * scaleToNatural / cropZoom;

                  ctx.drawImage(imgEl, sx, sy, sSize, sSize, 0, 0, outputSize, outputSize);

                  canvas.toBlob(async (blob) => {
                    if (!blob) return;
                    const croppedFile = new File([blob], "profile.jpg", { type: "image/jpeg" });
                    setProfilePhotoUrl(URL.createObjectURL(croppedFile));
                    setCropModalOpen(false);
                    setUploadingPhoto(true);
                    try {
                      const id = Number(localStorage.getItem("id"));
                      await updateMyProfilePicture(token, id, croppedFile);
                    } catch (err) { console.error(err); }
                    finally { setUploadingPhoto(false); }
                  }, "image/jpeg", 0.9);
                }}
                style={{ padding: "7px 18px", borderRadius: 6, border: "none", background: "#2563eb", color: "#fff", fontSize: 13, fontWeight: 600 }}>
                Save Photo
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── CHANGE PASSWORD MODAL ── */}
      <Modal
        show={showChangePasswordModal}
        onHide={() => { resetChangePasswordForm(); setShowChangePasswordModal(false); }}
        centered className="cpw-modal"
      >
        <div className="cpw-header">
          <div className="cpw-header-left">
            <div className="cpw-icon"><i className="bi bi-shield-lock-fill"></i></div>
            <div>
              <div className="cpw-title">Change Password</div>
              <div className="cpw-subtitle">Keep your account secure</div>
            </div>
          </div>
          <button className="cpw-close-btn" onClick={() => { resetChangePasswordForm(); setShowChangePasswordModal(false); }}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="cpw-body">
          {[
            { label: "Current Password", icon: "bi-lock", val: currentPassword, onChange: handleCurrentPasswordChange, show: showCurrentPassword, setShow: setShowCurrentPassword, err: currentPasswordError, ph: "Enter current password" },
            { label: "New Password", icon: "bi-key", val: newPassword, onChange: handleNewPasswordChange, show: showNewPassword, setShow: setShowNewPassword, err: newPasswordError, ph: "Enter new password" },
            { label: "Confirm Password", icon: "bi-check-circle", val: confirmNewPassword, onChange: handleConfirmNewPasswordChange, show: showConfirmPassword, setShow: setShowConfirmPassword, err: confirmNewPasswordError, ph: "Confirm new password" },
          ].map((f, idx) => (
            <div key={idx} style={{ marginBottom: "16px" }}>
              <div className="cpw-field-label">
                <i className={`bi ${f.icon}`} style={{ color: "#2563eb" }}></i> {f.label}
              </div>
              <div className="cpw-input-wrap">
                <input
                  className={`cpw-input${f.err ? " has-error" : ""}`}
                  type={f.show ? "text" : "password"}
                  value={f.val}
                  onChange={f.onChange}
                  placeholder={f.ph}
                />
                <button className="cpw-eye-btn" type="button" onClick={() => f.setShow(v => !v)}>
                  <i className={f.show ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </button>
              </div>
              {/* strength bar — width & background stay inline (dynamic per password strength) */}
              {idx === 1 && newPassword && (
                <div className="cpw-strength">
                  <div className="cpw-strength-bar" style={{
                    width: newPassword.length < 6 ? "25%" : newPassword.length < 8 ? "50%" : validatePassword(newPassword) === "" ? "100%" : "75%",
                    background: newPassword.length < 6 ? "#ef4444" : newPassword.length < 8 ? "#f59e0b" : validatePassword(newPassword) === "" ? "#10b981" : "#f59e0b",
                  }}></div>
                </div>
              )}
              {f.err && <div className="cpw-error"><i className="bi bi-exclamation-circle-fill"></i>{f.err}</div>}
              {idx === 2 && confirmNewPassword && !f.err && (
                <div style={{ fontSize: "12px", color: "#10b981", marginTop: "5px", display: "flex", alignItems: "center", gap: "4px" }}>
                  <i className="bi bi-check-circle-fill"></i> Passwords match
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="cpw-footer">
          <button className="cpw-btn-cancel" onClick={() => { resetChangePasswordForm(); setShowChangePasswordModal(false); }}>Cancel</button>
          <button className="cpw-btn-save" onClick={handleChangePassword} disabled={isChangingPassword}>
            {isChangingPassword
              ? <><i className="bi bi-arrow-repeat" style={{ animation: "spin 1s linear infinite" }}></i> Saving…</>
              : <><i className="bi bi-shield-check"></i> Change Password</>}
          </button>
        </div>
      </Modal>

    </>
  );
};

export default NavbarPage;
